import React, {useRef, useState, useEffect} from 'react';
import Drawer from '@mui/material/Drawer'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import DetailsPallet from './DetailsPallet';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText'
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography'
import orderHelpers from '../../../helpers/orders';

function OrderDetails(props) { 

    const order = props.order || {};
    const containerRef = useRef({});

    const [status, setStatus] = useState({});

    useEffect(() => {
        console.log(order);
    }, )


    return (
        <Drawer open = {Object.keys(order).length > 0} onClose = {props.setOpenDetails} anchor = "bottom">
            <Box style = {{height: "600px"}}  display = "flex" sx = {{m:"auto", mb:"80px", pt:"20px"}}>
                <List dense>
                    <ListItem>
                        <ListItemText 
                            primary = "PO Order Num" 
                            primaryTypographyProps = {{variant:"h5"}} 
                            secondaryTypographyProps = {{variant:"h6"}} 
                            secondary = {order.poNum || "N/A"} />
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary = "Shipment Date" 
                            secondary = {order.shipmentDate ? order.shipmentDate.substring(0, 10) : "N/A"}/>
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary = "Acumatica Order" 
                            secondary = {order.orderNum || "N/A"}/>
                    </ListItem>
                    <ListItem>
                        <ListItemText 
                            primary = "Geodis Order" 
                            secondary = {order.orderId || "N/A"}/>
                    </ListItem>
                </List>
                <Divider sx = {{ml:"10px", mr:"10px"}} orientation = "vertical" flexItem />
                <Box display = "flex" flexDirection = "column">
                    <h3>Customer Info</h3>
                    <Box display = "flex">
                        <List dense>
                        <ListItem>
                                <ListItemText 
                                    primary = "Name" 
                                    secondary = {order?.shipTo?.shipName || "N/A"}/>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary = "Street Address" 
                                    secondary = {order?.shipTo?.addr1 || "N/A"}/>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary = "Street Address 2" 
                                    secondary = {order?.shipTo?.addr2 || "N/A"}/>
                            </ListItem>
                        </List>
                        <List dense>
                            <ListItem>
                                <ListItemText 
                                    primary = "City" 
                                    secondary = {order?.shipTo?.city || "N/A"} />
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary = "State" 
                                    secondary = {order?.shipTo?.region || "N/A"} />
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary = "Zip Code" 
                                    secondary = {order?.shipTo?.postalcode || "N/A"} />
                            </ListItem>
                        </List>
                    </Box>
                </Box>
                <Divider sx = {{ml:"10px", mr:"10px"}} orientation = "vertical" flexItem />
                {order?.shipment?.carton ? 
                    <Box display = "flex" flexDirection = "column" >
                        <Tabs value = {props.tab} onChange = {props.setTab}>
                            {order.shipment.carton.map((shipment, index) => {
                                return(
                                    <Tab 
                                        value = {index} 
                                        name = {index} 
                                        key = {index} 
                                        label = {`Pallet ${index + 1}`} 
                                    />
                                )
                            })}
                        </Tabs>
                        {order.shipment.carton.map((ship, index) => {
                            return(
                                <Box ref = {containerRef[index]} key = {index} display = "flex" flexDirection = "column" style = {{overflowX:"hidden"}}>
                                    <Slide mountOnEnter unmountOnExit container = {containerRef[index]?.current} direction = {props.direction} in = {props.tab === index}>
                                        <Box>
                                        {props.tab === index ? <DetailsPallet {...props} status = {status} internal_po_number = {order.internal_po_number} palletNum = {props.tab} shipment = {ship} />  : null}
                                        </Box>
                                    </Slide>
                                </Box>
                            )
                        })}
                        {/* // {order.shipments.length > props.tab ? <DetailsPallet PalletNum={props.tab} shipment={order.shipments[props.tab]} /> : null} */}
                    </Box> 
                : null
                }
            </Box>
        </Drawer>
    )
}

export default OrderDetails;


